import styled from 'styled-components';

export const StyledAccordionTrigger = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: ${(p) =>
    p.isPadded
      ? `${p.theme.space[2]} ${p.theme.space[6]}`
      : `${p.theme.space[2]} ${p.theme.space[3]}`};
  position: relative;
  z-index: 1;
  text-align: left;

  &:hover::before {
    background-color: ${(p) => p.theme.alias.shadow};
  }

  &:focus-visible {
    box-shadow: ${(p) => p.theme.shadows.focusOuter};
  }

  &::before {
    content: '';
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    position: absolute;
  }
`;
